/**
 * Shared type definitions for LEGO entities
 */

/**
 * Entity types in plural form (used in URLs and API endpoints)
 */
export type EntityTypePlural = 'sets' | 'parts' | 'minifigs' | 'elements';

/**
 * Entity types in singular form (used in tracking and internal logic)
 */
export type EntityTypeSingular = 'set' | 'part' | 'minifig' | 'element';

/**
 * Convert plural entity type to singular
 */
export function toSingular(plural: EntityTypePlural): EntityTypeSingular {
  // Remove trailing 's' to convert plural to singular
  return plural.slice(0, -1) as EntityTypeSingular;
}

/**
 * Convert singular entity type to plural
 */
export function toPlural(singular: EntityTypeSingular): EntityTypePlural {
  // Add trailing 's' to convert singular to plural
  return (singular + 's') as EntityTypePlural;
}
